import { gql } from '@apollo/client';
import { AppFragment } from './App';
import { ProductVariantFragment } from './Variant';

export const OptionFragment = gql`
  fragment OptionFragment on MenuOption {
    name
    posId
    min
    max
    mmId
    source
    customPosId
    clonedPosId
    variants {
      ...ProductVariantFragment
    }
  }

  ${AppFragment}
  ${ProductVariantFragment}
`;

const PosOptionFragment = gql`
  fragment PosOptionsFragment on PosOption {
    name
    posId
    min
    max
    source
    customPosId
    variants {
      customPosId
      name
      posId
      price
    }
  }
`;

export const posOptionQuery = gql`
  query posOption($locationId: String!, $posId: String!) {
    posOption(locationId: $locationId, posId: $posId) {
      ...PosOptionsFragment
    }
  }

  ${PosOptionFragment}
`;

export const SearchOptionsQuery = gql`
  query SearchOptions($searchTerm: String!, $locationId: String!, $offset: Int!) {
    searchGlobalPosOptions(locationId: $locationId, searchInput: { searchTerm: $searchTerm, offset: $offset }) {
      items {
        ...PosOptionsFragment
      }
      limit
      offset
      count
    }
  }

  ${PosOptionFragment}
`;

export const SearchGlobalPosOptionsByPosIds = gql`
  query SearchOptionsByPosIds($posIds: [String!]!, $locationId: String!) {
    searchGlobalPosOptionsByPosIds(locationId: $locationId, posIds: $posIds) {
      items {
        ...PosOptionsFragment
      }
      limit
      offset
      count
    }
  }

  ${PosOptionFragment}
`;

export const SearchProductOptionsQuery = gql`
  query SearchProductOptions($locationId: String!, $productPosId: String!, $searchTerm: String!) {
    searchProductPosOptions(locationId: $locationId, productPosId: $productPosId, searchTerm: $searchTerm) {
      ...PosOptionsFragment
    }
  }

  ${PosOptionFragment}
`;

export const PosOptionPrices = gql`
  query posOptionPrices($locationId: String!, $posId: String!) {
    posOption(locationId: $locationId, posId: $posId) {
      posId
      name
      variants {
        posId
        price
        name
      }
    }
  }
`;
